<div class="container">
    <div class="exchange-card">
        <app-exchange-card
            title="Exchange Online"
            (onSubmitForm)="handleAuthenticateExchangeOnline($event)"
        ></app-exchange-card>
    </div>
    <div class="exchange-card">
        <app-exchange-card
            title="Exchange On-Prem"
            [requiresPassword]="true"
            (onSubmitForm)="handleAuthenticateExchange($event)"
        ></app-exchange-card>
    </div>
</div>

<div class="ui active inverted dimmer" *ngIf="isAuthenticating">
    <div class="ui text loader">
        <p>Authenticating...</p>
    </div>
</div>
